module.exports = __webpack_public_path__ + "img/image-placeholder.3f444bfd.svg";